var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-popup',{attrs:{"close-on-popstate":true,"position":"bottom"},model:{value:(_vm.showReason),callback:function ($$v) {_vm.showReason=$$v},expression:"showReason"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"选择取消原因","columns":_vm.reasonList},on:{"cancel":_vm.toggle,"confirm":_vm.confirm}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }